import { Box, BoxProps, Container, Flex, Heading } from '@chakra-ui/react';
import { CMS } from '@waitroom/models';
import * as React from 'react';
import Markdown from '../../Markdown/Markdown';
import Row from '../../Row/Row';

const colors = ['red.500', 'red.900', 'orange.500', 'red.700', 'orange.700'];

const BlockList = ({
  heading,
  content,
  blocks,
  ...rest
}: CMS.BlockList & BoxProps): React.ReactElement | null => {
  return (
    <Box {...rest}>
      <Container maxW="container.2xl" textAlign="center">
        {heading || content ? (
          <Box mb={12}>
            {heading ? (
              <Heading as="h4" size="4xl" mb={4}>
                {heading}
              </Heading>
            ) : null}
            {content && (
              <Markdown fontSize={['lg', 'xl', 'xl', '2xl']} mb={4}>
                {content}
              </Markdown>
            )}
          </Box>
        ) : null}
        <Row
          space={2}
          rowGap={4}
          display="flex"
          flexWrap="wrap"
          fontSize={['lg', 'xl', 'xl', '2xl']}
          fontWeight="bold"
          //color="blackAlpha.700"
          color="white"
        >
          {blocks?.map((block, i) => (
            <Flex
              key={i}
              flexGrow={1}
              flexShrink={0}
              w={{
                base: '100%',
                md: '50%',
                lg: i % 5 > 2 ? '50%' : '33.33%',
              }}
            >
              <Flex
                key={i}
                w="100%"
                height="100px"
                rounded="lg"
                align="center"
                justify="center"
                wordBreak="break-word"
                p={2}
                bg={colors[i % 5]}
              >
                {block}
              </Flex>
            </Flex>
          ))}
        </Row>
      </Container>
    </Box>
  );
};
export default BlockList;
